/*
 * Copyright © 2017-2026 Knowledge for Decisions (K4D). All rights reserved.
 *
 * This code and associated materials are protected by copyright laws and international
 * treaties. Unauthorized use, reproduction, distribution, or modification of any content
 * from Knowledge for Decisions (K4D) is strictly prohibited. For inquiries regarding
 * the use or licensing of K4D's copyrighted materials, please contact us at
 * contact@k4d.com.br. "Knowledge for Decisions (K4D)" and the slogan "Using data to make
 * precise decisions" are registered trademarks of Knowledge for Decisions (K4D).
 */

import { useEffect } from 'react';
import {
  addGlobalRequestLoading,
  removeGlobalRequestLoading,
} from '@/context/LoadingContext';

/**
 * Drives the global "Sincronizando" corner pill while a content surface is in its
 * loading state. Registers one request-loading tick on the global loading store
 * when `active` becomes true and releases it when `active` turns false or the
 * surface unmounts. This makes the pill appear for BOTH a real list fetch and a
 * Dev Cockpit simulated-loading override, since both drive `DataState`'s loading
 * branch. The store's own `!isLoading` guard keeps the pill hidden during the
 * full-screen splash, and its min-display/hide-delay keeps the enter/leave smooth.
 *
 * @param active True while the surface should surface the corner pill.
 */
export function useContentLoadingPill(active: boolean): void {
  useEffect(() => {
    if (!active) return;
    addGlobalRequestLoading();
    return () => {
      removeGlobalRequestLoading();
    };
  }, [active]);
}
